import { useMemo } from "react";
import { usePumpSizing } from "../../../context/PumpSizingContext";
import { SEWAGE_FIXTURE_UNITS } from "../../../data/gpm";
import { TextField } from "../../shared/TextField";

export function GpmSewageHelp() {
	const { formData, setSewageFixtureUnit } = usePumpSizing();
	const { sewage } = formData.gpmData;

	const columns = useMemo(() => {
		const columnSize = Math.ceil(SEWAGE_FIXTURE_UNITS.length / 3);
		return [
			SEWAGE_FIXTURE_UNITS.slice(0, columnSize),
			SEWAGE_FIXTURE_UNITS.slice(columnSize, columnSize * 2),
			SEWAGE_FIXTURE_UNITS.slice(columnSize * 2),
		];
	}, []);

	return (
		<div className="pf-gpm-help pf-gpm-help--sewage">
			<p className="pf-gpm-help__section-label">Fixture Units</p>
			<div className="pf-fixture-units-grid">
				{columns.map((column, columnIndex) => (
					<div key={columnIndex} className="pf-fixture-units-grid__column">
						{column.map((fixture) => (
							<TextField
								key={fixture.id}
								label={fixture.label}
								type="number"
								value={sewage.fixtureUnits[fixture.id] ?? "0"}
								onChange={(event) =>
									setSewageFixtureUnit(fixture.id, event.target.value)
								}
								min="0"
								step="1"
							/>
						))}
					</div>
				))}
			</div>
			<p className="pf-fixture-units-total">
				<strong>Total Fixture Units:</strong> {sewage.totalFixtureUnits}
			</p>
		</div>
	);
}
